/**
 * Trunca uma string se ela exceder o limite de caracteres
 * @param {string} text - Texto a ser truncado
 * @param {number} maxLength - Número máximo de caracteres (padrão: 20)
 * @returns {string} Texto truncado com "..." se necessário
 */
export const truncateString = (text, maxLength = 20) => {
  if (!text || typeof text !== 'string') {
    return '';
  }

  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
};

export default truncateString;
